import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from "aurelia-dependency-injection";
import { bindable } from "aurelia-templating";
import { DocumentRequirementApi } from "../../../apis/document-requirement.api";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { Router } from "aurelia-router";
import { DocumentManagementRoutes } from '../../../constants/route.constant';
import { computedFrom } from 'aurelia-binding';
import { UserClaimsService } from '@rightship-tech/common-ui/services/basic/user-claims.service';
import { DocumentManagmentClaims } from '../../../constants/claims.constants';
import { Messages } from '@rightship-tech/common-ui/constants/event-messages.constants';
import { GetVesselDocumentRequirementsCount, VesselDocumentRequirementsCount } from '../../../models/document-management.models';

@autoinject
export class PartialDocumentRequirementsWidget {

    @bindable
    public hasBorder: boolean = true;

    @bindable
    public vesselId: number;
    
    public isLoading: boolean = true;
    public currentCarouselPageNumber: number = 0;
    public carouselDocumentRequirements: VesselDocumentRequirementsCount[][] = [];
    public showDocumentRequirementInHome: boolean;
    public canAccessDocumentRequirements: boolean;

    constructor(private configService: ConfigService, private router: Router, private documentRequirementApi: DocumentRequirementApi,
        private userClaimsService: UserClaimsService, private eventAggregator: EventAggregator) {
        
        //Claims
        this.showDocumentRequirementInHome = this.userClaimsService.hasPermission(DocumentManagmentClaims.ShowDocumentRequirementInHome);
        this.canAccessDocumentRequirements = this.userClaimsService.hasPermission(DocumentManagmentClaims.CanaccessDocumentRequirements);
    }

    async attached() {

        if (this.vesselId) { 
            var response: GetVesselDocumentRequirementsCount = null;

            //If requesting party
            if (this.showDocumentRequirementInHome) {
                response = await this.documentRequirementApi.getCustomerSubscribedVesselDocumentsCount(this.vesselId);
            }
            else if (this.canAccessDocumentRequirements) {
                response = await this.documentRequirementApi.getCustomerVesselDocumentsCount(this.vesselId);
            }
            
            if (!response?.vesselDocumentRequirementsCounts || response?.vesselDocumentRequirementsCounts.length == 0 || !response?.isSuccess) {
                this.isLoading = false;
                return;
            }

            //Group document requirements into items of 3 for carousel
            for (let i = 0; i < response.vesselDocumentRequirementsCounts.length; i += 3) {
                this.carouselDocumentRequirements.push(response.vesselDocumentRequirementsCounts.slice(i, i + 3));
            }
        }

        //Stop loading
        this.isLoading = false;
    }

    @computedFrom("carouselDocumentRequirements", "currentCarouselPageNumber")
    get disableNextCarouselPage() {
        return this.carouselDocumentRequirements.length <= this.currentCarouselPageNumber + 1;
    }

    @computedFrom("carouselDocumentRequirements", "currentCarouselPageNumber")
    get disablePreviousCarouselPage() {
        return this.currentCarouselPageNumber == 0;
    }

    //Next carousel page
    public nextCarouselPage() {
        if (!this.disableNextCarouselPage) {
            this.currentCarouselPageNumber++;
        }
    }

    //Previous carousel page
    public previousCarouselPage() {
        if (!this.disablePreviousCarouselPage) {
            this.currentCarouselPageNumber--;
        }
    }

    //Navigate to all documents within My Vessels app
    public allDocuments() {
        this.eventAggregator.publish(Messages.changeTabToDocuments, {});
    }

    //Navigate to add requirements
    public addRequirements() {
        this.router.navigateToRoute(DocumentManagementRoutes.AddDocumentRequirements, { documentRequirementId: 0 });
    }

    //Navigate to manage document requirements
    public manageDocumentRequirements() {
        window.location.href = this.configService.config.urls.myVesselsUrl + "/manage-document-requirements";
    }

    //Navigate to document tab
    public navigateToDocumentsTab(id: number) {
        this.eventAggregator.publish(Messages.changeTabToDocuments, { requirementId: id });
    }
}